export const useGetReportTypes = () => {
  return {
    reportTypes: [
      { id: 1, value: 'country', name: 'Country' },
      { id: 2, value: 'asset', name: 'Asset' },
      { id: 3, value: 'corporate', name: 'Corporate' },
    ],
  };
};
